export default __webpack_public_path__ + "static/media/bg_2.83e73378.png";